import styled from 'styled-components';

export const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.lightGray};
  padding: 80px 0;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  
  h2 {
    text-align: center;
    margin-bottom: 3rem;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2.5rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

export const ProgramCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

export const ProgramIcon = styled.div`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 1rem;
`;

export const ProgramTitle = styled.h3`
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 1rem;
  font-size: 1.2rem;
`;

export const ProgramDescription = styled.p`
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 0.9rem;
  line-height: 1.6;
`;